import { createStore, applyMiddleware } from "redux";
import productsReducer from "./products/productsReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import { validate } from "./middleware/validate";

const store = createStore(
  productsReducer,
  composeWithDevTools(applyMiddleware(validate))
);

export default store;
